module.exports = __webpack_public_path__ + "static/img/Homev3.298204e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/Homev3.jpg
// module id = AVu3
// module chunks = 0